import { useQuery } from '@tanstack/react-query';

import {
    eventDashboardStatsQueryOptions,
    selectTicketsSoldStats,
} from '../eventDashboardStatsQueryOptions';

type UseEventDashboardTicketsSoldOptions = {
    eventId: number | undefined;
    timezone: string;
};

/** Tickets Sold card hook — shared dashboard cache, `selectTicketsSoldStats` for the card shape. */
export function useEventDashboardTicketsSold({
    eventId,
    timezone,
}: UseEventDashboardTicketsSoldOptions) {
    return useQuery({
        ...eventDashboardStatsQueryOptions({ eventId, timezone }),
        select: selectTicketsSoldStats,
    });
}
